import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=9670ea48&scoped=true"
import script from "./Achievement.vue?vue&type=script&lang=js"
export * from "./Achievement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9670ea48",
  null
  
)

export default component.exports